var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4Bnb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 9.46548L9.46582 11.9998L12.0001 14.534L14.5344 11.9998L12.0001 9.46548Z",
    fill: "#EBE417"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53428 9.46548L1 11.9998L3.53428 14.534L6.06856 11.9998L3.53428 9.46548Z",
    fill: "#EBE417"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 6.06913L16.2331 10.3017L18.7677 7.76718L12.0005 1L5.2334 7.76718L7.76801 10.3017L12.0005 6.06913Z",
    fill: "#EBE417"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 17.9308L7.76801 13.6982L5.2334 16.2327L12.0005 22.9999L18.7677 16.2327L16.2331 13.6982L12.0005 17.9308Z",
    fill: "#EBE417"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4659 9.46548L17.9316 11.9998L20.4659 14.534L23.0002 11.9998L20.4659 9.46548Z",
    fill: "#EBE417"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Bnb);
export default __webpack_public_path__ + "static/media/4.BNB.53288f6510c9b4f704b7dbff5722e008.svg";
export { ForwardRef as ReactComponent };